import React from 'react';
import ReactDOM from 'react-dom/client';
import './i18n/config';
import { bootstrapAuthFromUrl } from './services/api';
import App from './App';

bootstrapAuthFromUrl();

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
